import { openDB } from 'idb';

export const dbPromise = openDB('mvl-store', 2, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('products')) {
      db.createObjectStore('products', { keyPath: 'id' });
    }

    if (!db.objectStoreNames.contains('meta')) {
      db.createObjectStore('meta', { keyPath: 'key' });
    }
  }
});


export async function saveProducts(products) {
  const db = await dbPromise;
  const tx = db.transaction(['products', 'meta'], 'readwrite');

  for (const product of products) {
    tx.objectStore('products').put(product);
  }

  tx.objectStore('meta').put({
    key: 'products_last_updated',
    value: Date.now()
  });

  await tx.done;
}
export async function getProductsLastUpdated() {
  const db = await dbPromise;
  const meta = await db.get('meta', 'products_last_updated');
  return meta?.value || 0;
}


export async function getAllCachedProducts() {
  const db = await dbPromise;
  return db.getAll('products');
}

export async function clearProducts() {
  const db = await dbPromise;
  const tx = db.transaction(['products', 'meta'], 'readwrite');

  await tx.objectStore('products').clear();
  await tx.objectStore('meta').clear();

  await tx.done;
}

